import { Component, Inject, OnInit } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-expense-dashboard-details',
  templateUrl: './expense-dashboard-details.component.html',
  styleUrls: ['./expense-dashboard-details.component.scss'],
})
export class ExpenseDashboardDetailsComponent implements OnInit {
  dropdownSettings: IDropdownSettings = {};
  getStatusList: any = [];
  selectedSatus: any = [];
  currentData: any = [];
  approvedReimbursment: any = [];
  rejectedReimbursment: any = [];
  expenseApproved: any = [];
  penddingReimbursment: any = [];
  employeeData: any = [];
  moduleName: any;
  loggedInUserId: any;
  isToggleOn: boolean = true;
  type: any = "Approved";
  taskColumnHeaderInfoForFinanse: any = []
  allTeamMemberReimbursementApprove: any = []
  approveMatrixValueForCondition: any
  loggedInUserRole: any | null;
  loggedInUserRoles: any;
  employeeApproved: any = []
  employeePendding: any = [];
  employeeRejected: any = [];
  employeApprovedOrRejected: any = [];
  raisedEmployeeUnderManager: any;
  approvedEmployeeUnderManager: any;
  rejectedEmployeeUnderManager: any;
  pendingEmployeeUnderManager: any;
  undeManagerAprrovedreject: any = [];
  employeIDFromUserTable: any = []
  underManagerAprrovedreject: any = [];
  pendingWithManager: any = [];

  formatedataVariable = formatText;
  OnlyFinance: any;
  rejectedEmployeeUnderFinance: any;
  approvedEmployeeUnderFinance: any;
  pendingEmployeeUnderFinance: any;
  raisedEmployeeUnderFinance: any[]=[];
  underFinanceAprrovedreject: any;
  loggedInUserCompanyID: any;
  selectUserIdForManager: any;
  arrEmployeeDetiails: any = [];
  isApprovedByEnabled: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private datePipe: DatePipe, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService,) {
     
    this.arrEmployeeDetiails = data.arrEmployeeDetiails;
    this.loggedInUserId=data.loggdingUserId;
    this.selectUserIdForManager = data.userID;
    this.moduleName = data.moduleName;
  }
  
  
  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.getAllEmployeeListing();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.approveMatrixValueForCondition = this.httpService.passApprovematrixForReport;
    this.hederlable();
    this.getEmployee();
 
    setTimeout(() => {
      this.OnlyFinance = sessionStorage.getItem('financeAdminId') == this.loggedInUserId;
      
        
    }, 0)

  }


  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.employeIDFromUserTable = data.data;
      
    })
    
  }
 
  
  hederlable() {

    const taskColumnHeaderInfoForFinanceHRAdmin = [
      { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
      { label: 'Reimbursement type', isMandatory: true, sortingName: 'reimbursementType' },
      { label: 'Date of Apply', isMandatory: true, sortingName: 'startDate' },
      { label: 'Date of Expense', isMandatory: true, sortingName: 'dateOfExpense' },
      // { label: 'Reimbursement Id', isMandatory: true, sortingName: 'reimbursementId' },
      { label: 'Limit of reimbursement', isMandatory: true, sortingName: 'reimbursementLimit' },
      { label: 'Actual amount', isMandatory: true, sortingName: 'actualAmount' },
      { label: 'Actual amount by finance', isMandatory: true, sortingName: 'actualAmountByFinance' },
      { label: 'Attach document proof', isMandatory: true, sortingName: 'attachDocumentProof' },
      { label: 'Status', isMandatory: true, sortingName: 'status', width: '280px' },
      { label: 'Employee comment', isMandatory: false, sortingName: 'employeeComment' },
      { label: 'Finance comment', isMandatory: false, sortingName: 'financeComment' },
      { label: 'Approval', isMandatory: true, sortingName: 'approvalStatus' }
    ];
   
    
    if (this.approveMatrixValueForCondition != 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = { label: 'Manager comment', isMandatory: false, sortingName: 'managerComment' };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(column => column.sortingName === 'employeeComment');
      taskColumnHeaderInfoForFinanceHRAdmin.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    // Dynamically add "Approved By" column
    if ( this.moduleName == 1 && (sessionStorage.getItem('financeAdminId') == this.loggedInUserId  || this.loggedInUserRole === 'HR Admin') ) {
      this.isApprovedByEnabled = true;
      const approvedByColumn = { label: 'Approved By', isMandatory: true, sortingName: 'ApprovedBy' };
      // Insert "Approved By" before "Approval"
      const approvalIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(  column => column.sortingName === 'approvalStatus'  );
      if (approvalIndex > -1) {
        taskColumnHeaderInfoForFinanceHRAdmin.splice(approvalIndex, 0, approvedByColumn);
      }
    }

    this.taskColumnHeaderInfoForFinanse = taskColumnHeaderInfoForFinanceHRAdmin
    

  }

  getAllEmployeeListing() {

  
    this.httpService.reimbursementData$.subscribe((data) => { 

      this.allTeamMemberReimbursementApprove = [];
   
      this.allTeamMemberReimbursementApprove = data;
      this.employeeData = data.filter((elm: any) => elm.employeeId == this.loggedInUserId || elm.financeId == this.loggedInUserId)
      this.employeeApproved = this.employeeData.filter((elm: any) => elm.approvedStatus == 'APPROVED');
      this.employeeRejected = this.employeeData.filter((elm: any) => elm.approvedStatus == 'REJECTED');

      if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
        this.employeePendding = this.employeeData.filter((elm: any) => (elm.approvedStatus == 'PENDING'));
      }else{
        this.employeePendding = this.employeeData.filter((elm: any) => (elm.approvedByManager == 'APPROVED' && elm.approvedStatus == 'PENDING'));

      }  


      this.employeApprovedOrRejected = this.type == "Approved" ? this.employeeApproved : this.employeeRejected
      this.approvedReimbursment = data.filter((elm: any) => elm.approvedStatus == 'APPROVED');
      this.rejectedReimbursment = data.filter((elm: any) => elm.approvedStatus == 'REJECTED')
      this.expenseApproved = this.type == "Approved" ? this.approvedReimbursment : this.rejectedReimbursment;
      this.penddingReimbursment = data.filter((elm: any) => (elm.approvedStatus == 'PENDING' && elm.approvedByManager == 'APPROVED'));
      //----------------------------------- Start manager----------------------------------------
      let employeeIdData = this.employeIDFromUserTable.map((elm: any) => elm.id)
      let ManagerEmployeeDorpDownData = data.filter((record: any) => record.employeeId == this.selectUserIdForManager);
      this.raisedEmployeeUnderManager = data.filter((record: any) => record.employeeId == this.selectUserIdForManager);
      
      this.pendingWithManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedByManager == null && this.loggedInUserId != record.employeeId);
      
      
      this.approvedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'APPROVED');
      this.rejectedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'REJECTED');
      this.pendingEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => (record.approvedByManager == 'APPROVED' && record.approvedStatus == 'PENDING'));
      this.pendingEmployeeUnderManager = this.moduleName === 'Manager' ? this.pendingWithManager : this.pendingEmployeeUnderManager;
      
      this.underManagerAprrovedreject = this.type == "Approved" ? this.approvedEmployeeUnderManager : this.rejectedEmployeeUnderManager;
      //-----------------------------------end manager----------------------------------------
      //----------------------------------- Start finance----------------------------------------
      
      let employeeIds =this.employeIDFromUserTable.map((elm:any)=>elm.id)
    
      
      let FinanceDorpDownData = data.filter((record: any) => employeeIds.includes(record.employeeId) || record.financeId == this.loggedInUserId);
 
      if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
        
        this.raisedEmployeeUnderFinance = data.filter((elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))

        this.approvedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'APPROVED');
        this.rejectedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'REJECTED');
        this.pendingEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => ( record.approvedStatus == 'PENDING'));

      }else{
        
        this.raisedEmployeeUnderFinance = data.filter((elm: any) => elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))

        this.approvedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'APPROVED' && record.financeId == this.loggedInUserId);
        this.rejectedEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => record.approvedStatus == 'REJECTED' && record.financeId == this.loggedInUserId);
        this.pendingEmployeeUnderFinance = this.raisedEmployeeUnderFinance.filter((record: any) => (record.approvedByManager == 'APPROVED' && record.approvedStatus == 'PENDING'));

      }  

      this.underFinanceAprrovedreject = this.type == "Approved" ? this.approvedEmployeeUnderFinance : this.rejectedEmployeeUnderFinance;
      
      //-----------------------------------end Finance----------------------------------------
      if (this.loggedInUserRole == 'Employee' && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
        
          this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? this.employeeData :
            this.moduleName === 4 ? this.employeePendding : this.employeApprovedOrRejected;
            this.currentData =  this.allTeamMemberReimbursementApprove;
        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
       
      } else if (this.loggedInUserRole == 'Manager' && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
        console.log("inside manager Not Finance");
        
        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? this.raisedEmployeeUnderManager :
          (this.moduleName === 4 || this.moduleName === 'Manager') ? this.pendingEmployeeUnderManager : this.underManagerAprrovedreject;
        this.currentData = this.allTeamMemberReimbursementApprove;
        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
      }
      else if (sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
        console.log("inside... Finance ");
        
        const arrExpensData = data;

        arrExpensData.forEach(expense => {
          let matchingUser = this.arrEmployeeDetiails.find((user: any) =>
            user.id.toString() === expense.financeId?.toString() // Ensure both are strings
          );
          if (matchingUser) {
            expense.financeName = `${matchingUser.firstName} ${matchingUser.lastName}`;
          } else {
            expense.financeName = '';
          }
        });

        

        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ? arrExpensData :
          this.moduleName === 4 ? this.pendingEmployeeUnderFinance : this.underFinanceAprrovedreject;
        this.currentData = this.allTeamMemberReimbursementApprove;
        

        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
      }
      else {
        console.warn("HR ADMIN")
        
          const arrExpensData = this.allTeamMemberReimbursementApprove;

        arrExpensData.forEach((expense: { financeId: { toString: () => any; }; financeName: string; }) => {
          let matchingUser = this.arrEmployeeDetiails.find((user: any) =>
            user.id.toString() === expense.financeId?.toString() // Ensure both are strings
          );
          if (matchingUser) {
            expense.financeName = `${matchingUser.firstName} ${matchingUser.lastName}`;
          } else {
            expense.financeName = '';
          }
        });

        this.allTeamMemberReimbursementApprove = this.moduleName === 1 ?arrExpensData :
          this.moduleName === 4 ? this.penddingReimbursment : this.expenseApproved;
          this.currentData =  this.allTeamMemberReimbursementApprove;
        ManagerEmployeeDorpDownData = this.allTeamMemberReimbursementApprove;
      }
      this.getStatusList = ManagerEmployeeDorpDownData
        .map((ele: any) => ({
          id: ele.reimbursementApplicationId,
          name: ele.approvedStatus
        }))
        .filter((value, index, self) =>
          index === self.findIndex((t) => (
            t.name === value.name
          ))
        );

    })


  }
  // Budget vs actual Increment Graph 

  onSelectStatus() {
    if (this.selectedSatus.length > 0) {

      this.filterSatus();
    }
  };

  onDeSelectStatus() {
    this.filterSatus();
  };

  selectAllStatus(data: any) {
    console.log(data);

    this.onSelectStatus();
  };

  onDeSelectAllStatus() {
    this.filterSatus();
    this.selectedSatus = [];

  };

  filterSatus() {
    if (this.selectedSatus.length > 0) {
      const status = this.selectedSatus.map((record: any) => record.name);
      this.allTeamMemberReimbursementApprove = this.currentData.filter((elm: any) => status.includes(elm.approvedStatus));
      console.log(this.allTeamMemberReimbursementApprove);

    } else {
      this.allTeamMemberReimbursementApprove = this.currentData;
    }
  }


  exportDashboardListExcel() {
    if (!this.allTeamMemberReimbursementApprove.length) {
      alert('No data to download!');
      return;
    }

    // Define the fields to be downloaded
    const exportFields = [
      'employeeName',
      'reimbursementType',
      'date',
      'dateOfExpense',
      'reimbursementLimit',
      'actualAmount',
      'assignedAmount',
      'uploadDocument',
      'status',
      'employeeComment',
      'financeComment',
      'approvedStatus'
    ];

    // Extract headers for the selected fields
    
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const financeCommentIndex = exportFields.indexOf('financeComment');
      if (financeCommentIndex !== -1) {
        exportFields.splice(financeCommentIndex, 0, 'managerComment');
      }
    }

    const header = this.taskColumnHeaderInfoForFinanse.map((column: any) => column.label);
    // Extract rows with only the selected fields
    let dateChgeArray:any=[];
    dateChgeArray=this.allTeamMemberReimbursementApprove.map((elm:any)=>{
      return{
        ...elm,
        date: this.datePipe.transform(elm.date, 'dd-MM-yyyy'),
        status: formatText(elm.status)
      }
    })
    const rows =dateChgeArray.map((record: any) =>

      exportFields.map(field => `"${record[field] || ''}"`).join(',')
    );

    // Create the CSV content
    const csvContent = [header, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const data = this.type == 'Approved' ? 'Expense Approved' : 'Expense Rejected';
    const moduleName = this.moduleName == 1 ? 'Expense Raised' : (this.moduleName == 4 || this.moduleName == 'Manager') ? 'Expense Pending' : data;
    // Trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = `${moduleName}${new Date()}`
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;

    if (event?.checked == true) {
      this.type = 'Approved';
      if ((this.moduleName == 3) && event?.checked == true) {
        this.type = 'Approved';
      }
      this.getAllEmployeeListing()
    } else if (event?.checked == false) {
      this.type = 'Rejected';
      if ((this.moduleName == 3) && event?.checked == false) {
        this.type = 'Rejected';
      }
      this.getAllEmployeeListing()
    }
  }
}
